// Общий QueryClient приложения. Повторы — только сеть/5xx/429 (429 — не раньше Retry-After сервера).
// Опрос в фоне: «фокус» TanStack Query = видимость вкладки браузера И активность Mini App в Telegram (activated /
// deactivated, Bot API 8.0: на десктоп-клиентах свёрнутая Mini App не меняет visibilityState). Не в фокусе — запросы с
// refetchInterval не опрашивают (refetchIntervalInBackground: false); вернулись — немедленный запрос устаревшего
// (refetchOnWindowFocus). Экранам достаточно поставить refetchInterval.
import { focusManager, QueryClient } from '@tanstack/react-query';
import { retryDelay, shouldRetry } from './client';
import { onActivityChange } from '../telegram/webapp';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: shouldRetry, retryDelay, refetchOnWindowFocus: true, refetchIntervalInBackground: false, gcTime: 30 * 60_000 },
  },
});

/** Видимость документа + активность Telegram → focusManager. activity — источник событий Telegram (тесты подставляют). */
export function bindQueryFocus(activity: (cb: (active: boolean) => void) => () => void = onActivityChange): void {
  focusManager.setEventListener((setFocused) => {
    let visible = typeof document === 'undefined' || document.visibilityState !== 'hidden';
    let active = true;
    const update = () => setFocused(visible && active);
    const onVisibility = () => { visible = document.visibilityState !== 'hidden'; update(); };
    if (typeof document !== 'undefined') document.addEventListener('visibilitychange', onVisibility);
    const offTelegram = activity((next) => { active = next; update(); });
    return () => {
      if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', onVisibility);
      offTelegram();
    };
  });
}
